import React from 'react'
import { csx } from '@vtex/admin-ui'

import { ProductDetails, ProductDetailsSection } from '..'
import type { ProductSpecificationsDrawer_Product$key } from '../ProductSpecifications/__generated__/ProductSpecificationsDrawer_Product.graphql'
import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'
import { ProductSpecifications } from '../ProductSpecifications'

type ProductDetailsSectionContentProps = {
  productDescription: ProductDetailsDrawer_Product$key | null
  productSpecifications: ProductSpecificationsDrawer_Product$key | null
}

export const ProductDetailsSectionContent = ({
  productDescription,
  productSpecifications,
}: ProductDetailsSectionContentProps) => {
  return (
    <ProductDetailsSection className={csx({ marginTop: '$space-8' })}>
      <ProductDetails productDescription={productDescription} />
      <ProductSpecifications productSpecifications={productSpecifications} />
    </ProductDetailsSection>
  )
}
